import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NGX_ECHARTS_CONFIG, NgxEchartsModule } from 'ngx-echarts';
import { DialogComponent } from 'src/app/@core/components/ui/dialog/dialog.component';

@Component({
  selector: 'app-custom-graph-model',
  standalone: true,
  imports: [
    DialogComponent,
    NgxEchartsModule
  ],
  providers: [
    {
      provide: NGX_ECHARTS_CONFIG,
      useValue: {
        echarts: () => import('echarts')
      }
    }
  ],
  templateUrl: './custom-graph-model.component.html',
  styleUrl: './custom-graph-model.component.scss'
})
export class CustomGraphModelComponent implements OnInit {
  @Input() public data: any = {};
  public OpenGraphDialog: boolean = false;
  @Input() public expandable: boolean = true;
  @Input() public url: string = '';
  @Input() public customStyles: string = '';

  constructor(private http: HttpClient) { }

  ngOnInit() {
    if (this.url) {
      this.fetchDataFromUrl(this.url);
    } else {
      this.initializeChartOptions();
    }
  }

  private initializeChartOptions() {
    // Initialize with default values if not provided
    this.data = {
      ...this.data,
      tooltip: {
        trigger: 'item'
      },
      legend: {
        ...(this.data?.legend || {}),
        top: "10%",
        type: "scroll",
        orient: 'horizontal',
      },
      title: {
        ...(this.data?.title || {}),
        textStyle: {
          fontSize: 16
        }
      }
    };

    // Special handling for radar type
    if (this.data?.radar) {
      // Ensure radar configuration is properly structured
      this.data.radar = {
        ...(this.data.radar || {}),
        radius: "60%",
        shape: 'polygon',
        indicator: Array.isArray(this.data.radar.indicator) ? this.data.radar.indicator : [],
        splitArea: {
          show: true
        },
        axisName: {
          show: true
        }
      };

      // Ensure series is properly structured for radar
      if (this.data?.series) {
        if (!Array.isArray(this.data.series)) {
          this.data.series = [this.data.series];
        }

        this.data.series = this.data.series.map((series: any) => ({
          type: 'radar',
          ...series,
          symbol: 'none',
          areaStyle: {
            ...(series.areaStyle || {}),
            opacity: 0.3
          },
          lineStyle: {
            ...(series.lineStyle || {}),
            width: 2
          }
        }));
      }
    } else {
      // Handle non-radar chart configurations
      if (this.data?.xAxis) {
        this.data.xAxis = {
          ...(this.data?.xAxis || {}),
          type: "category",
          axisLabel: {
            formatter: function (value: string) {
              return value.split(" ").join("\n");
            }
          }
        };
      }

      if (this.data?.yAxis) {
        this.data.yAxis = {
          ...(this.data?.yAxis || {}),
          type: "value",
          axisLabel: {
            formatter: function (value: number) {
              return value.toFixed(2);
            }
          }
        };
      }

      this.data.grid = {
        top: "25%",
        containLabel: true
      };
    }
  }

  openModel() {
    this.OpenGraphDialog = !this.OpenGraphDialog;
  }

  fetchDataFromUrl(url: string) {
    this.http.get(url).subscribe((data: any) => {
      this.data = data;
      this.initializeChartOptions();
    });
  }
}
